"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = require("react");

const SnackbarProvider_1 = require("../providers/SnackbarProvider");

const useSnackbars = () => react_1.useContext(SnackbarProvider_1.SnackbarContext);

exports.default = useSnackbars;